import { useId } from 'react';
import './graphit-loader.css';

/**
 * Animated Graphit loading mark.
 * size: px (number) or any CSS length. variant: 'badge' (navy disc) | 'plain' (no disc; G and bars use currentColor).
 */
export default function GraphitLoader({ size = 48, label = 'Loading', variant = 'badge', className = '' }) {
  const clipId = `gl-bowl-${useId().replace(/:/g, '')}`;
  const dimension = typeof size === 'number' ? `${size}px` : size;
  const classes = ['gl-root', variant === 'plain' ? 'gl-plain' : '', className].filter(Boolean).join(' ');
  return (
    <span className={classes} role="status" aria-label={label} style={{ width: dimension, height: dimension }}>
      <svg viewBox="0 0 120 120" aria-hidden="true" focusable="false">
        <circle className="gl-disc" cx="60" cy="60" r="58" />
        <defs><clipPath id={clipId}><circle cx="60" cy="60" r="30" /></clipPath></defs>
        <g clipPath={`url(#${clipId})`}>
          <g className="gl-bars">
            <rect className="gl-bar" x="42" y="64" width="6" height="26" rx="1.2" />
            <rect className="gl-bar" x="51" y="56" width="6" height="34" rx="1.2" />
            <rect className="gl-bar" x="60" y="48" width="6" height="42" rx="1.2" />
            <rect className="gl-bar" x="69" y="40" width="6" height="50" rx="1.2" />
          </g>
          <path className="gl-wave" d="M18 77q6-5 12 0t12 0t12 0t12 0t12 0t12 0t12 0t12 0V100H18Z" />
        </g>
        <path className="gl-g" d="M85.46 34.54A36 36 0 1 0 96 60H76" />
      </svg>
    </span>
  );
}
